export default __webpack_public_path__ + "static/char-s-06-chs-3f75be34fc2a10e7d72f85713048e068.webp";